import { render, staticRenderFns } from "./PxSelect.vue?vue&type=template&id=fe275dc6&"
import script from "./PxSelect.vue?vue&type=script&lang=js&"
export * from "./PxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports